import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import { useClient } from '../../../ClientProvider';
import { mergeMutationState } from '../../../mergeState';
import useMutation from '../../../useMutation';
import { useArvalisSetupInfos } from './useArvalisSetupInfos';
/**
 * Create a client and a technician,
 * to be used on org activation (buy)
 */
const useArvalisClientCreation = ({ activateOption, currentOrgId, useToasts }) => {
    const client = useClient();
    const { t } = useIntl();
    const { addToast } = useToasts();
    const { org, setupInfos, clientId, techId } = useArvalisSetupInfos({ currentOrgId });
    // TODO: If we query the client and it does not exist, we would not create it hence not calling the onSuccess (addTechnician), despite the technician potentially not being created
    // But actually we update the client & technician each time
    // const arvalisClientRequest = useQuery(
    //   client.waterBalanceArvalis.getClient({ clientId: clientId as string }),
    //   {
    //     enabled: !isNil(clientId),
    //     retry: false
    //   }
    // )
    const [createArvalisTechnician, createArvalisTechnicianRequest] = useMutation(client.waterBalanceArvalis.addTechnician(), {
        onSuccess: () => {
            addToast(t(`actions.edit_success`), { appearance: 'success' });
        }
    });
    const [createArvalisClient, createArvalisClientRequest] = useMutation(client.waterBalanceArvalis.addClient(), {
        onSuccess: () => {
            createArvalisTechnician({
                ...setupInfos,
                techId: techId?.toString(),
                clientId: clientId?.toString()
            });
        }
    });
    const state = mergeMutationState(createArvalisTechnicianRequest, createArvalisClientRequest);
    const handleSubmit = (cropType) => {
        activateOption({
            organizationId: org?.id,
            optionSettings: !isNil(cropType) ? { organization: { crop: cropType } } : undefined
        });
        createArvalisClient({
            ...setupInfos,
            firstName: '',
            lastName: org?.name ?? '',
            clientId: clientId?.toString()
        });
    };
    return { handleSubmit, state };
};
export default useArvalisClientCreation;
